import { PanelContainer } from '../../../common/panel/PanelContainer'
import { FinancialAnalysis } from './financialAnalysis'
import { FinancialStatement } from './financialStatement'
import { OwnershipAndGroup } from './ownershipAndGroup'
import { Score } from './score'
import HeaderSearch from './search'

export const PremiumUserContent = () => {
  return (
    <>
      <HeaderSearch />

      <PanelContainer>
        <OwnershipAndGroup />
        <FinancialStatement />
        <FinancialAnalysis />
        <Score />
      </PanelContainer>
    </>
  )
}
